import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'v2-center',
  template: ` <ng-content></ng-content> `,
  styles: [
    `
      :host {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
      }
    `
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class V2Center {}
